import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/collectors.js';
import q from '../query.js';
export const collectorsEntity = `collectors`;
const collectorKey = (id) => `collectors-${id}`;
export const useCollector = (id) => q.query(collectorKey(id), () => api.getById(id), keys.read.item(collectorsEntity, id), {
    enabled: id != null,
});
const allCollectorsKey = () => `all-collectors`;
export const useAllCollectors = () => q.query(allCollectorsKey(), () => api.getAll(), keys.read.collection(collectorsEntity));
//# sourceMappingURL=index.js.map